























import _ from 'lodash'
import Vue from 'vue'

export default Vue.extend({
    props: {
        value: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: true
        },
        clearable : {
            type : Boolean,
            required: false,
            default : true
        },
        min: {
            type: String,
            required: false,
            default: '2000-01-01'
        },
        max: {
            type: String,
            required: false,
            default: new Date().getFullYear() + '-12-31'
        }
    },
    data: function() {
        return {
            menuDateDebut: '',
            oldValue: ''
        }
    },
    methods: {
        getOldValue(keyEvent: KeyboardEvent) {
            const oldValue = (keyEvent.target as HTMLInputElement).value
            if (/^[0-9]{0,2}\/?[0-9]{0,2}\/?[0-9]{0,4}$/.test(oldValue)) this.oldValue = oldValue
        },
        verifyNewValue(keyEvent: KeyboardEvent) {
            const input = keyEvent.target as HTMLInputElement
            const newValue = input.value
            const start = input.selectionStart,
                end = input.selectionEnd
            const testsAjoutSlash = [
                /^[0-9]{2}$/, // Deux premiers chiffres
                /^[0-9]{2}\/[0-9]{2}$/ // Deux premiers chiffres, un / et deux seconds chiffres
            ]

            const testDeuxChiffres = /^[0-9]{2}.*$/
            const testQuatreChiffres = /^[0-9]{2}\/[0-9]{2}.*$/
            const testHuitChiffres = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}.*$/

            const tests = [
                /^[0-9]{0,2}$/, // Zero ou deux premiers chiffres
                /^[0-9]{2}\/$/, // Deux premiers chiffres et un /
                /^[0-9]{2}\/[0-9]{0,2}$/, // Deux premiers chiffres, un / et zero ou deux seconds chiffres
                /^[0-9]{0,2}\/[0-9]{0,2}$/, // Deux premiers chiffres, un / et zero ou deux seconds chiffres
                /^[0-9]{2}\/[0-9]{2}\/$/, // Deux premiers chiffres, un /, deux seconds chiffres et un /
                /^[0-9]{2}\/[0-9]{2}\/[0-9]{0,4}$/, // Deux premiers chiffres, un /, deux seconds chiffres, un / et zero ou quatres premiers chiffres
                /^[0-9]{0,2}\/[0-9]{0,2}\/[0-9]{0,4}$/ // Zero ou deux premiers chiffres, un /, zero ou deux seconds chiffres, un / et zero ou quatres premiers chiffres
            ]
            if (!_.some(tests, t => t.test(newValue))) input.value = this.oldValue
            // if(testDeuxChiffres.test(newValue) && parseInt(newValue.slice(0,2)) > 31) {
            //     input.value = 31 + newValue.slice(2)
            // }
            // console.log(newValue.slice(3,5))
            // if(testQuatreChiffres.test(newValue) && parseInt(newValue.slice(3,5)) > 12) {
            //     input.value = newValue.slice(0,3) + 12 + newValue.slice(5)
            // }

            // Si on est pas dans le cas d'un delete, on ajoute automatiquement le / à la fin
            if (['Backspace', 'Delete'].indexOf(keyEvent.code) == -1 && _.some(testsAjoutSlash, t => t.test(newValue))) input.value = newValue + '/'
        },
        checkDateMinEtMax(date: string) {
            if (date < this.min && this.min) return this.min
            else if (date > this.max && this.max) return this.max
            return date
        },
        saveDate(date: string) {
            this.$emit('input', date)
            this.$emit('change', date)
        }
    },
    computed: {
        dateFormatee: {
            get(): string {
                console.log('dateFormatee get')
                if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(this.value)) {
                    const [year, month, day] = this.value.split('-')
                    return `${day}/${month}/${year}`
                } else {
                    return ''
                }
            },
            set(date: string) {
                const valueInputHTML = this.$refs.textfield as HTMLInputElement
                console.log('dateFormatee set', date, valueInputHTML.value)
                if (/^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/.test(date)) {
                    const [day, month, year] = date.split('/')
                    const dateToSave = this.checkDateMinEtMax(`${year}-${month}-${day}`)
                    console.log(dateToSave)
                    this.saveDate(dateToSave)
                }
            }
        },
        dateDatePicker: {
            get(): string {
                console.log('dateDatePicker get')
                return this.value
            },
            set(date: string) {
                console.log('dateDatePicker set')
                const dateToSave = this.checkDateMinEtMax(date)
                this.saveDate(dateToSave)
            }
        }
    },
    watch: {
        dateFormatee: function(new_, old) {
            console.log(new_, old)
        }
    }
})
